/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import Request from "../../utils/request";
import utils from "../../utils/utils";
import "./style.less";

class PipelineSubsidy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  componentDidMount() {
    this.getProductData();
  }

  getProductData() {
    const itemList = this.props.config.itemList;
    const itemObjData = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemObjData[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    const productType = this.props.config.baseConfig.type;
    if (productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "配色id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "skuId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
    }

    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const dataList = res.data.data.List || [];
        dataList.forEach((product) => {
          try {
            const itemData = itemList.find((dataItem) => dataItem.id === product.id);
            if (itemData) {
              product.useCustomName = itemData.useCustomName;
              product.name = itemData.name;
            }
          } catch (error) {
            const itemDataBeta = itemObjData[product.id];
            if (itemDataBeta) {
              product.useCustomName = itemDataBeta.useCustomName;
              product.name = itemDataBeta.name;
            }
          }
        });
        this.setState({
          list: dataList,
        });
      }
    });
  }

  productClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      name: item.title,
      sort: index
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    console.log(this.props);
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);
  };

  render() {
    const { baseConfig } = this.props.config;
    baseConfig.itemMargin = isNaN(Number(baseConfig.itemMargin))
      ? 0
      : Number(baseConfig.itemMargin);
    const rowItemNumber = 3; // 每行数量个数
    
    return (
      <div
        className="pipeline-subsidy"
        {...this.props['customAttributes']}
        style={{
          paddingTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="title-wrapper">
          <div className="title" style={{ color: baseConfig.titleColor }}>{baseConfig.title}</div>
          <div className="sub-title" style={{ color: baseConfig.titleColor }}>{baseConfig.subTitle}</div>
        </div>
        <div className="subsidy-list">
          {this.state.list.map((item, index) => {
            // 计算折扣差价
            let discount = Number(item.original_price) - Number(item.price);
            discount = parseInt(discount);
            if (discount < 0 || isNaN(discount)) {
              discount = 0;
            }

            // 行数计算
            const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
            const totalRowNum = Math.ceil(this.state.list.length / rowItemNumber);
            const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
            const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 计算每个项的宽度
            const totalMargin = (rowItemNumber - 1) * baseConfig.itemMargin;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
              marginTop: isFirstRow ? "0" : `${baseConfig.itemMargin / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
              marginLeft: isFirstColumn
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
              marginRight: isLastColumn
                ? "0"
                : `${baseConfig.itemMargin / 2}px`,
            };
            return (
              <div
                className="subsidy-item"
                key={index}
                onClick={this.productClick.bind(this, item, index)}
                style={itemStyle}
              >
                <div
                  className="img-container"
                  style={{
                    backgroundImage: `url(${utils.formatImgUrl(item.image, this.props.webpSupport)})`,
                  }}
                ></div>
                {Boolean(discount) && (
                  <div className="price-tip">直降{discount}元</div>
                )}
                <div className="product-info">
                  <div className="name">
                    {item.useCustomName ? item.name : item.title}
                    <div className="fade-mask"></div>
                  </div>
                  <div className="price">
                    <span className="price-addon">补贴价</span>
                    <span className="rmb-icon">&yen;</span>
                    {item.price}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

PipelineSubsidy.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSubsidy };
export default PipelineSubsidy;



// WEBPACK FOOTER //
// ./components/pipeline-subsidy/index.js